import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { LoadingService } from 'src/app/_services/loading.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { Title } from '@angular/platform-browser';
import { DialogService } from 'src/app/_services/dialog.service';
import { CouponService } from '../_ecomservices/coupon.service';

@Component({
  selector: 'app-coupons',
  templateUrl: './coupons.component.html',
  styleUrls: ['./coupons.component.css']
})
export class CouponsComponent implements OnInit {

  couponDisplayedColumns: string[] = ['ID', 'CouponCode', 'Description', 'DiscountType',
    'DiscountValue', 'MinimumOrderValue', 'MaximumDiscount', 'DateRange', 'Usage', 'Action'];
  couponDataSource: MatTableDataSource<any>;

  constructor(public couponService: CouponService,
    private dialog: MatDialog,
    private titleService: Title,
    private loading: LoadingService,
    private notificationService: NotificationService,
    public dialogService: DialogService,) { }

  ngOnInit() {
    this.titleService.setTitle('Product Coupon');
    this.get_all_coupons();
  }

  onCreateCoupon() {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '10px' }
    this.dialog.open(CouponCreateComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.get_all_coupons();
    });
  }

  onEdit(rowData: any) {
    this.couponService.populateForm(rowData);
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '10px' };
    // matDialogConfig.data = { couponId: couponId }
    this.dialog.open(CouponCreateComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.get_all_coupons();
    });
  }

  get_all_coupons() {
    var result = this.couponService.get_all_coupons().subscribe(data => {
      //console.log(data);
      if (data['status']) {
        this.couponDataSource = new MatTableDataSource<any>(data['coupons']);
      }
    });
  }

  onDeleteCoupon(coupon: any) {
    this.dialogService.openConfirmDialog('Are you sure want to delete this coupon?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.loading.spin$.next(true);
          this.couponService.delete_coupon(coupon.id).subscribe(data => {
            if (data['status']) {
              this.notificationService.success(data['message']);
              this.get_all_coupons();
              this.loading.spin$.next(false);
            }
            else {
              this.notificationService.error('Product coupon could not be deleted, Try Again!');
              this.loading.spin$.next(false);
            }
          });
        }
      });
  }

  toggleCouponStatusChange(event: any, couponId: any) {
    let checked = event.checked;
    let status = checked ? 1 : 0;
    this.couponService.update_coupon_status(couponId, status).subscribe(data => {
      console.log(data);
    });
  }

}




/* Create Coupon */
@Component({
  selector: 'create-coupon-dialog',
  templateUrl: 'create-coupon-dialog.html',
})
export class CouponCreateComponent {

  constructor(
    private dialogRef: MatDialogRef<CouponsComponent>,
    public couponService: CouponService,
    private loading: LoadingService,
    private notificationService: NotificationService,
  ) {
  }


  onCouponAddedFormSubmit(formData: any) {
    if (this.couponService.coupon_form.valid) {
      this.loading.spin$.next(true);
      if (!this.couponService.coupon_form.controls['id'].value) {
        // Insert Data
        this.couponService.insert_coupon(formData).subscribe(data => {
          //console.log(data);
          if (data['status']) {
            this.notificationService.success(data['message']);
            this.couponService.coupon_form.reset();
            this.onClose();
            this.loading.spin$.next(false);
          }
          else {
            this.notificationService.error('Coupon could not be created, Try Again!');
            this.loading.spin$.next(false);
          }
        });
      }
      else {
        // Update Data
        //console.log('data updated');
        this.couponService.update_coupon(formData).subscribe(data => {
          console.log(data);
          if (data['status']) {
            this.notificationService.success(data['message']);
            this.couponService.coupon_form.reset();
            this.onClose();
            this.loading.spin$.next(false);
          }
          else {
            console.log('error');
            this.notificationService.error(data['message']);
            this.loading.spin$.next(false);
          }
        });
      }
    }
  }


  onClose() {
    // console.log('Close');
    this.couponService.coupon_form.reset();
    this.dialogRef.close();
  }

}

